export default __webpack_public_path__ + "static/media/13-Shore-Up-Your-Defenses.cdcbdd3d.jpg";